import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import quickUpdatesServices from '../../services/quickUpdates/quickUpdatesServices';
import { quickUpdateActionTypes } from '../../actions/quickUpdate/quickUpdateActions';

function* _quickUpdateEntityWise(action) {
  try {
    const response = yield quickUpdatesServices.quickUpdateEntityWise(action.payload);
    if (response.success) {
      notification.open({
        type: 'success',
        message: response?.message,
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback(response);
      }
    } else {
      notification.error({
        message: response?.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (action?.rollback) {
      action.rollback();
    }
  } catch (error) {
    notification.error({
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* quickUpdateEntityWise() {
  yield takeLatest(quickUpdateActionTypes.QUICK_UPDATE_ENTITY_WISE.REQUEST, _quickUpdateEntityWise);
}

export default function* quickUpdateSaga() {
  yield all([
    quickUpdateEntityWise(),
  ]);
}
